module.exports = __webpack_public_path__ + "img/323.d833c1ed.svg";